<template>
  <div class="wrapper border-bottom white-bg page-heading">
    <div class="container">
      <div class="row">
        <div class="col-xs-12">
          <heading-loading v-if="loading"></heading-loading>
          <h1 v-else>
            <i class="far fa-wallet m-r-sm"></i> Credit Notes
            <template v-if="editingDifferentUser">/ {{ user.profile.full_name }}</template>
          </h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { existingUser } from 'mixins/user'
  import { headingLoading } from 'mixins'

  export default {
    mixins: [existingUser, headingLoading]
  }
</script>



// WEBPACK FOOTER //
// CreditNotesHeading.vue?063d1c2c